import { render, staticRenderFns } from "./inbtracking_main.vue?vue&type=template&id=470b8e84&scoped=true"
import script from "./inbtracking_main.vue?vue&type=script&lang=js"
export * from "./inbtracking_main.vue?vue&type=script&lang=js"
import style0 from "./inbtracking_main.vue?vue&type=style&index=0&id=470b8e84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470b8e84",
  null
  
)

export default component.exports